import * as styles from './Calendar.module.scss';

export function CalendarMarker() {
  return <span className={styles.dot} />;
}
